let EAM_Allowance_Status = [
  {
    label: "All",
    value: -1,
  },
  {
    value: 22,
    label: "Pending For Payment",
  },
  {
    value: 27,
    label: "Payment Reject",
  },
  {
    value: 18,
    label: "Payment Approve",
  },
  {
    value: 19,
    label: "Payment Receive",
  },
  {
    value: 25,
    label: "Payment Finish",
  },
  {
    value: 28,
    label: "Payment Refer Back",
  },
  {
    value: 31,
    label: "Payment Receive Refer Back",
  },
  // {
  //   value: 31,
  //   label: "Claim Approved",
  // },
  // {
  //   value: 32,
  //   label: "Claim Received",
  // },
  // {
  //   value: 33,
  //   label: "Claim Finished",
  // },
  // {
  //   value: 34,
  //   label: "Claim Refer Back",
  // },
  // {
  //   value: 35,
  //   label: "Claim Rejected",
  // },
];

let EAM_Benefit_Status = [
  {
    label: "All",
    value: -1,
  },
  {
    value: 22,
    label: "Pending For Payment",
  },
  { value: 27, label: "Payment Reject" },
  {
    value: 18,
    label: "Payment Approve",
  },
  {
    value: 19,
    label: "Payment Receive",
  },
  {
    value: 25,
    label: "Payment Finish",
  },
  {
    value: 28,
    label: "Payment Refer Back",
  },
  {
    value: 31,
    label: "Payment Receive Refer Back",
  },
];

export { EAM_Allowance_Status, EAM_Benefit_Status };
